module.exports = __webpack_public_path__ + "static/tri-e54913820b26c130926caa38ebcde56a.gif";